export var TransactionType;
(function (TransactionType) {
    TransactionType["TRANSFER_IN"] = "transfer_import";
    TransactionType["TRANSFER_OUT"] = "transfer_export";
})(TransactionType || (TransactionType = {}));
//# sourceMappingURL=TransactionType.js.map